<template>
    <div id="personal-information">
        <v-card-title class="pb-0">
            <v-icon :color="kingsGold" left>mdi-account</v-icon> Personal Information
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-account-box</v-icon>Basic Information
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.firstName" hide-details label="First Name"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.lastName" hide-details label="Last Name" placeholder="Not Available"
                            readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.preferredName" hide-details label="Preferred Name (Optional)"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.dateOfBirth" hide-details label="Date of Birth"
                            placeholder="Not Available" prepend-icon="mdi-calendar-account" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-select v-model="item.gender" hide-details :items="genderItems" label="Gender"
                            placeholder="Not Available" readonly>
                        </v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field v-model="item.prefpronoun" hide-details label="Preferred Pronoun"
                            placeholder="Not Available" readonly
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-checkbox
                            v-model="item.sixftorover"
                            label="6' or taller"
                            hide-details
                            readonly
                            value="yes"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="6" v-if="item.sixftorover == 'yes'">
                        <v-select v-model="item.sixftoroverdetail" dense :items="sixftoroverdetailitems" label="Height: " outlined readonly></v-select>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-home</v-icon>Address Information
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12" md="8">
                        <v-text-field v-model="item.address" hide-details label="Home Address"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.postalCode" hide-details label="Postal Code"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.country" hide-details label="Country" placeholder="Not Available"
                            readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.city" hide-details label="City" placeholder="Not Available"
                            readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select v-model="item.province" hide-details :items="provinceItems" label="Province"
                            placeholder="Not Available" readonly>
                        </v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.provinceOther" hide-details label="Province (Other)"
                            placeholder="None" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-card-account-details</v-icon>Contact Information
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.homePhone" hide-details label="Home Phone"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.cellPhone" hide-details label="Cell Phone"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.email" hide-details label="Email" placeholder="Not Available"
                            readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="item.emailPersonal" label="Email (Personal)" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="item.emailPersonalConfirmed" label="Confirm Email (Personal)" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-school</v-icon>Academic Information
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="item.studentnumber" hide-details :counter="9" label="Student Number"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.registeredAt" hide-details label="Registered at"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.yearOfStudy"
                            hint="Note: During the upcoming academic year"
                            label="Year of study at King's University College" persistent-hint
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-calendar-range</v-icon>Residence Term
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="item.residenceTerm" hide-details label="Residence Term"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-information</v-icon>Additional Information
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="item.internationalStudent" hide-details label="International Student"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" class="pt-4">
                        <v-textarea v-model="item.healthDietaryConcern" auto-grow
                            hint="Specify any health/dietary concern(s) that could be relevant to your stay in residence"
                            label="Health/Dietary Concern(s)" outlined persistent-hint placeholder="None" readonly>
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'application-personal-information',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            genderItems: [{
                    text: 'Female',
                    value: 'F'
                },
                {
                    text: 'Male',
                    value: 'M'
                },
                {
                    text: 'Non-Binary',
                    value: 'NonBinary'
                }
            ],
            provinceItems: [{
                    text: 'Alberta',
                    value: 'AB'
                },
                {
                    text: 'British Columbia',
                    value: 'BC'
                },
                {
                    text: 'Manitoba',
                    value: 'MB'
                },
                {
                    text: 'New Brunswick',
                    value: 'NB'
                },
                {
                    text: 'Newfoundland and Labrador',
                    value: 'NL'
                },
                {
                    text: 'Northwest Territories',
                    value: 'NT'
                },
                {
                    text: 'Nova Scotia',
                    value: 'NS'
                },
                {
                    text: 'Nunavut',
                    value: 'NU'
                },
                {
                    text: 'Ontario',
                    value: 'ON'
                },
                {
                    text: 'Prince Edward Island',
                    value: 'PE'
                },
                {
                    text: 'Quebec',
                    value: 'QC'
                },
                {
                    text: 'Saskatchewan',
                    value: 'SK'
                },
                {
                    text: 'Yukon',
                    value: 'YT'
                },
                {
                    text: 'Other',
                    value: 'Other'
                }
            ],
            sixftoroverdetailitems: [
                {text: "Please Select...", value: ""},
                {text: "6' 0”", value: "6.0"},
                {text: "6' 1”", value: "6.1"},
                {text: "6' 2”", value: "6.2"},
                {text: "6' 3”", value: "6.3"},
                {text: "6' 4”", value: "6.4"},
                {text: "6' 5”", value: "6.5"}
            ]
        }
    },
    computed: {
        kingsGold() {
            return '#d7ae28';
        }
    }
}
</script>

<style scoped>
.v-card__subtitle {
    font-weight: bold;
}
</style>